import React, { useCallback, useEffect, useRef, useState } from "react";

function zoneStatusColor(completionPct, openComplaints) {
  if (openComplaints > 5) return "#7a3030";
  if (completionPct >= 80) return "#3d7a50";
  if (completionPct >= 60) return "#7a6030";
  return "#7a3030";
}

function ZoneGrid({ zones, onZoneClick }) {
  const railRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateArrows = useCallback(() => {
    const el = railRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 4);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  }, []);

  useEffect(() => {
    updateArrows();
  }, [zones, updateArrows]);

  const scrollBy = (dir) => {
    const el = railRef.current;
    if (!el) return;
    const card = el.querySelector(".zcell");
    if (!card) return;
    const cardWidth = card.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(el).columnGap) || 10;
    const slide = 2 * (cardWidth + gap);
    el.scrollBy({ left: dir * slide, behavior: "smooth" });
  };

  if (!zones || zones.length === 0) return null;

  return (
    <div data-cy="zone-grid">
      <div className="sec-hdr">
        <div className="t-section">Zones</div>
        <div className="t-label">{zones.length} zones · {zones.reduce((s, z) => s + z.total, 0)} PCTs</div>
      </div>
      <div className="zrail-wrap">
        <div className="zrail" ref={railRef} onScroll={updateArrows}>
          {zones.map((zone) => {
            const color = zoneStatusColor(zone.completionPct, zone.openComplaints);
            return (
              <div
                key={zone.id}
                className="zcell"
                data-cy={`zone-cell-${zone.id}`}
                onClick={() => onZoneClick && onZoneClick(zone)}
              >
                <div className="zlbl">Zone {zone.id}</div>
                <div className="zn">
                  {zone.completionPct}
                  <span className="zunit">%</span>
                </div>
                <div className="zsub" style={{ color: "var(--t3)" }}>
                  {zone.takenOver}/{zone.total} taken over
                </div>
                <div className="zbar">
                  <div
                    className="zfill"
                    style={{ width: `${zone.completionPct}%`, background: color }}
                  />
                </div>
              </div>
            );
          })}
        </div>
        {canScrollLeft && (
          <button
            type="button"
            className="zrail-arrow left"
            aria-label="Scroll zones left"
            data-cy="zrail-arrow-left"
            onClick={() => scrollBy(-1)}
          >
            <svg viewBox="0 0 24 24"><polyline points="15,18 9,12 15,6" /></svg>
          </button>
        )}
        {canScrollRight && (
          <button
            type="button"
            className="zrail-arrow right"
            aria-label="Scroll zones right"
            data-cy="zrail-arrow-right"
            onClick={() => scrollBy(1)}
          >
            <svg viewBox="0 0 24 24"><polyline points="9,18 15,12 9,6" /></svg>
          </button>
        )}
      </div>
    </div>
  );
}

export default ZoneGrid;
